import { SharePointParentFolder } from '@cims-online/shared'
import CIMSFormItem from '../../../../../../../../../components/CIMSFormItem'
import CIMSSelect from '../../../../../../../../../components/CIMSSelect'
import { useOptions } from '../../../../../../../../../components/CIMSSelect/hooks/useOptions'
import { SharePointResourceFormItemsProps } from './types'
import { Button } from 'antd'

const SharePointResourceFormItems: React.VFC<
  SharePointResourceFormItemsProps
> = ({ projectOptions, loading, refetch }) => {
  const sharePointParentOptions = useOptions({
    items: SharePointParentFolder.values,
    sort: 'name',
    label: 'name',
    value: 'id',
  })
  return (
    <>
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ width: '100%' }}>
          <CIMSFormItem
            name="projectId"
            label="Project"
            required
            style={{ width: '100%' }}
          >
            <CIMSSelect
              simple
              loading={loading}
              options={projectOptions}
              allowClear
            />
          </CIMSFormItem>
        </div>
        <Button loading={loading} disabled={loading} onClick={() => refetch()}>
          Refetch
        </Button>
      </div>
      <CIMSFormItem name="sharePointParentId" label="SharePoint Parent">
        <CIMSSelect allowClear simple options={sharePointParentOptions} />
      </CIMSFormItem>
    </>
  )
}

export default SharePointResourceFormItems
